
import { User } from "@/types";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { formatCurrency } from "@/lib/utils";

interface ChildBalanceProps {
  child: User;
}

export function ChildBalance({ child }: ChildBalanceProps) {
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-lg">Current Balance</CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-3xl font-bold">{formatCurrency(child.balance)}</p>
      </CardContent>
    </Card>
  );
}
